/** 12847 → "12,8 mil"; 2100000 → "2,1 mi"; <1000 → literal. pt-BR. */
export function formatCompact(n: number | undefined | null): string {
  if (n == null || Number.isNaN(n)) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace('.', ',')} mi`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace('.', ',')} mil`;
  return String(n);
}

export interface Delta {
  pct: number;
  dir: 'up' | 'down' | 'flat';
  label: string;
}

/** delta % entre atual e anterior; dir para a pill. Null se faltar dado. */
export function computeDelta(current?: number, previous?: number): Delta | null {
  if (current == null || previous == null || previous === 0) return null;
  const pct = ((current - previous) / previous) * 100;
  const dir = pct > 0.05 ? 'up' : pct < -0.05 ? 'down' : 'flat';
  return { pct, dir, label: `${pct > 0 ? '+' : ''}${pct.toFixed(1).replace('.', ',')}%` };
}

/** "há X min/h/d" a partir de ISO. */
export function relativeSince(iso?: string): string {
  if (!iso) return 'nunca';
  const diff = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(diff)) return 'nunca';
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'agora';
  if (m < 60) return `há ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `há ${h} h`;
  return `há ${Math.floor(h / 24)} d`;
}

/** ISO country code (2 letras) → bandeira emoji + nome pt-BR (fallback: o próprio código). */
export function countryLabel(code: string): string {
  const names: Record<string, string> = {
    BR: 'Brasil', PT: 'Portugal', US: 'EUA', AR: 'Argentina', ES: 'Espanha',
    MX: 'México', CL: 'Chile', CO: 'Colômbia', UY: 'Uruguai', PY: 'Paraguai',
    IT: 'Itália', FR: 'França', DE: 'Alemanha', GB: 'Reino Unido', CA: 'Canadá',
  };
  const flag = /^[a-z]{2}$/i.test(code)
    ? String.fromCodePoint(...[...code.toUpperCase()].map((c) => 127397 + c.charCodeAt(0)))
    : '';
  return `${flag} ${names[code.toUpperCase()] ?? code}`.trim();
}
